import { render } from "./PaymentSidebar.vue?vue&type=template&id=4a18bf24&scoped=true"
import script from "./PaymentSidebar.vue?vue&type=script&lang=js"
export * from "./PaymentSidebar.vue?vue&type=script&lang=js"

import "./PaymentSidebar.vue?vue&type=style&index=0&id=4a18bf24&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a18bf24"]])

export default __exports__